import PropTypes from 'prop-types';
// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { Radio, RadioGroup, FormHelperText, FormControlLabel } from '@mui/material';

// ----------------------------------------------------------------------

RHFRadioGroup.propTypes = {
  name: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.string),
};

export default function RHFRadioGroup({ name, options, getOptionLabel, ...other }) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <div>
          <RadioGroup {...field} {...other}>
            {options.map((option, index) => (
              <FormControlLabel
                sx={{
                  "&:hover": {background: (theme) => theme.palette.grey[200]},
                  background: (theme) => field.value === option && theme.palette.grey[200],
                  mx: 0,
                  borderRadius: 1,
                  ...(other.hasborder &&
                    {
                      my: 1,
                      py: 0.8,
                      pr: 0.5,
                      border: (field.value === option) ? '1px solid black' : '1px solid rgba(145, 158, 171, 0.24)',
                    }
                  )
                }}
                key={option}
                value={option}
                control={<Radio />}
                label={getOptionLabel?.length ? getOptionLabel[index] : option}
              />
            ))}
          </RadioGroup>

          {!!error && (
            <FormHelperText error sx={{ mt: 0, px: 0 }}>
              {error.message}
            </FormHelperText>
          )}
        </div>
      )}
    />
  );
}
